import React , { useEffect , useCallback } from 'react';
import { API_URL } from '../../../actions/index';
import { Translate } from "react-localize-redux";
import { Link } from 'react-router-dom';
// import format from 'format-number';

import { translateDate, getAssetPath } from "../../../utils/utils";

import { useGlobalContext } from '../../context/GlobalContext';
import { getOfferAction } from '../../../actions/offersActions';

// import Input from "../../Partials/form_fields/Input";
import providerIcon  from "../../../assets/images/icons/provider_icon.svg";

// import Animation from "./Animations_Partials/Animation";
import Loader from "../../Partials/Loader";

export default function OfferView(props) {
  props.setActivePage("offers");

  const [ context , dispatch ] = useGlobalContext();

  const offer = context.offers.offer;

  const getOffer = useCallback(() => {
    getOfferAction( dispatch, props.match.params.id);
  }, [dispatch , props.match.params.id]);

  useEffect(() => {
    getOffer();
  }, [getOffer]);

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  function renderOffer() {
    return (
      <>
        <header className="page-header">
          <div className="icon">
            <img src={getAssetPath(providerIcon)} alt="icon-provider"/>
          </div>
          <h1>
            <span className="hide-mobile text" style={{ marginLeft: 0 }}>
              {offer.ref}
            </span>
          </h1>
        </header>

        <main className="page-content">

          <Link to={"/offers"} className="btn-edit mb-10">
            <button className="btn-edit" style={{ marginBottom: 10, width : 100}}><Translate id="btn.back"/></button>
          </Link>

          <Link to={`/offer-edit/${offer._id}`} className="btn-edit mb-10" style={{  marginLeft: 10}}>
            <button className="btn-edit" style={{ marginBottom: 10, width : 100}}><Translate id="btn.edit"/></button>
          </Link>

          <div className="row col-2">
            <div className="col-70">

              <div className="card">
                <div className="product-img">
                  {offer.image?.path && <a
                    href={`${API_URL}/files/${offer.image?.path.replace('upload/', '')}`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <img
                      src={`${API_URL}/files/${offer.image?.path.replace('upload/', '')}`}
                      alt="product"/>
                  </a>}
                  {offer.file?.path && (
                    offer.file.path.toLowerCase().endsWith('.pdf')
                      ? (
                          <a
                            href={`${API_URL}/files/${offer.file.path.replace('upload/', '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Voir la fiche produit (PDF)
                          </a>
                        )
                      : (
                          <a
                            href={`${API_URL}/files/${offer.file.path.replace('upload/', '')}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${API_URL}/files/${offer.file.path.replace('upload/', '')}`}
                              alt="fiche produit"
                            />
                          </a>
                        )
                  )}
              </div>

                <div className="information-container offer">

                  <p className="p-col-3 offer">
                    <span className="bold">
                      Avantage salon
                      {offer?.discount && <><br/>(Réduction) </>}
                      {!offer?.discount && offer?.gift && <><br/>(Cadeau) </>}
                      {!offer?.discount && !offer?.gift && offer?.punch && <><br/>(Coup de poing) </>}
                      :
                    </span><br/>
                    {offer?.discount && (
                      <span className="number bold text-orange">{offer.discount} %</span>
                    )}
                    {!offer?.discount && offer?.gift && (
                      <span className="number bold text-orange">{offer.gift}</span>
                    )}
                    {!offer?.discount && !offer?.gift && offer?.punch && (
                      <span className="number bold text-orange">{offer.punch}</span>
                    )}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Prix net HT :</span><br/>
                    <span className="number bold text-primary">{offer.price && offer.price.toFixed(2)} €</span>
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Prix PA :</span><br/>
                    <span className="number bold text-primary">{offer.pricePA} €</span>
                  </p>

                </div>

                <div className="information-container offer border">
                  <p className="p-col-3 offer">
                    <span className="bold">Fournisseur :</span><br/>
                    {offer.company.name}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Famille de produit :</span><br/>
                    {offer.product}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Numéro de dossier :</span><br/>
                    {offer.fileNumber}
                  </p>

                </div>

                <div className="information-container offer border">

                  <p className="p-col-3 offer">
                    <span className="bold">Code article :</span><br/>
                    {offer.code}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Référence produit :</span><br/>
                    {offer.ref}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Gencod :</span><br/>
                    {offer.gencod}
                  </p>

                </div>

                <div className="information-container offer border">

                  <p className="p-col-3 offer">
                    <span className="bold">Marque :</span><br/>
                    {offer.brand}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Désignation produit :</span><br/>
                    {offer.description}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Typo :</span><br/>
                    {offer.type}
                  </p>

                </div>

                <div className="information-container offer border">

                  <p className="p-col-3 offer">
                    <span className="bold">DEEE HT :</span><br/>
                    {offer.deee}
                  </p>

                  <p className="p-col-3 offer">
                    <span className="bold">Autres taxes : </span><br/>
                    {offer.tax}
                  </p>
                </div>

                <div className="information-container offer border">

                  <p className="p-col-3 offer">
                    <span className="bold">Colisage :</span><br/>
                    {offer.packing}
                  </p>

                  {offer.packing === 'box' && offer.boxProducts && offer.boxProducts.length > 0 && (
                    <div style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
                      <span className="bold" style={{ display: 'block', marginBottom: 10 }}>Détails box :</span>
                      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd' }}>
                        <thead>
                          <tr style={{ backgroundColor: '#f5f5f5' }}>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Gencod</th>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Libellé</th>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>Quantité</th>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>PA unitaire HT</th>
                            <th style={{ padding: '8px', textAlign: 'left', border: '1px solid #ddd' }}>DEEE/Ecomobilier HT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {offer.boxProducts.map((item, index) => (
                            <tr key={index}>
                              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.gencod || '-'}</td>
                              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.libelle || '-'}</td>
                              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.quantity || '-'}</td>
                              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.pricePA ? `${item.pricePA} €` : '-'}</td>
                              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.deee ? `${item.deee} €` : '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {offer.box && (
                        <div style={{ marginTop: 15 }}>
                          <span className="bold">Informations complémentaires :</span><br/>
                          <span>{offer.box}</span>
                        </div>
                      )}
                    </div>
                  )}

                </div>

                <span style={{ fontSize: 12 , opacity: 0.58 }} >
                  Crée le {translateDate(offer.createdAt, 'fr')} {offer?.user?.email && <>par {offer?.user?.email}</>}<br/>
                  Modifiée le {translateDate(offer.updatedAt, 'fr')}
                </span>
              
              </div>

            </div>
          </div>

        </main>
      </>
    );
  };

  return (
    <div className="page-container">
      {offer && offer.company ? 
        renderOffer()
      :
        <div style={{ height: '100vh'}}>
          <Loader />
        </div>
      }
    </div>
  );
};